import React, { useState, useEffect } from "react";
import { salesService } from "../../services/salesService";
import { getPrinterService } from "../../services/printer/MockPrinterService";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { Alert, AlertDescription } from "@/components/ui/Alert";
import { Printer, AlertCircle } from "lucide-react";
import LoadingSpinner from "../common/LoadingSpinner";
import ProductSummaryCard from "./ProductSummaryCard";
import { SalesMetricsDisplay } from "./sales/SalesMetricDisplay";
import { SalesTable } from "./sales/SalesTable";
import DateRangeFilter from "./DateRangeFilter";
import ArqueoButtons from "./arqueo/ArqueoButtons";

const ArqueoComponent = () => {
  const printerService = getPrinterService(); // Obtener la instancia del servicio
  const [state, setState] = useState({
    metrics: null,
    sales: null,
    isLoading: false,
    error: null,
    printers: [],
    dateRange: {
      startDate: new Date(),
      endDate: new Date(),
    //  closingTime: 4,
    },
  });

  useEffect(() => {
    loadInitialData();

    // Escuchar cambios en el estado del arqueo
    const handleArqueoStateChange = (event) => {
      console.log("Cambio de estado del arqueo detectado:", event.detail);
      if (event.detail.isActive) {
        loadInitialData();
      }
    };

    window.addEventListener("arqueoStateChanged", handleArqueoStateChange);
    return () => {
      window.removeEventListener("arqueoStateChanged", handleArqueoStateChange);
    };
  }, []);

  const loadInitialData = async (dateRange = null) => {
    setState((prev) => ({ ...prev, isLoading: true }));
    try {
      const [dailyMetrics, dailySales, savedPrinters] = await Promise.all([
        salesService.getMetrics(
          dateRange?.startDate,
          dateRange?.endDate,
        //  dateRange?.closingTime
        ),
        salesService.getDailySales(
          dateRange?.startDate,
          dateRange?.endDate,
          // dateRange?.closingTime
        ),
        loadSavedPrinters(),
      ]);

      setState((prev) => ({
        ...prev,
        metrics: dailyMetrics,
        sales: dailySales.data.salesByDate,
        printers: savedPrinters,
        isLoading: false,
        dateRange: dateRange || prev.dateRange,
      }));
    } catch (error) {
      setState((prev) => ({
        ...prev,
        error: error.message,
        isLoading: false,
      }));
    }
  };

  const loadSavedPrinters = () => {
    const savedPrinters = localStorage.getItem("connectedPrinters");
    return savedPrinters ? JSON.parse(savedPrinters) : [];
  };

  const handleDateRangeChange = (newDateRange) => {
    loadInitialData(newDateRange);
  };

  const handlePrintReport = async (printerId) => {
    try {
      if (!state.metrics) {
        throw new Error("No hay datos para imprimir");
      }

      const sales = await salesService.getDailySales(
        state.dateRange.startDate,
        state.dateRange.endDate,
      //  state.dateRange.closingTime
      );
      console.log("Resultante Arqueo: ", sales)
      await printerService.printDailyReport(printerId, sales);
    } catch (error) {
      setState((prev) => ({ ...prev, error: error.message }));
    }
  };

  if (state.isLoading) return <LoadingSpinner />;

  return (
    <div className="min-h-screen bg-orange-50 p-4">
      <div className="max-w-5xl mx-auto space-y-6">
        {/* Nuevo componente ArqueoButtons */}
        <ArqueoButtons />

        <DateRangeFilter onFilterChange={handleDateRangeChange} />

        {state.error && (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{state.error}</AlertDescription>
          </Alert>
        )}

        <Card className="border-orange-200">
          <CardHeader className="border-b border-orange-200 bg-orange-500">
            <CardTitle className="text-2xl text-white flex items-center">
              <Printer className="mr-2 h-6 w-6" />
              Arqueo del Período
            </CardTitle>
          </CardHeader>

          <CardContent className="space-y-6 pt-6">
            {state.metrics && (
              <SalesMetricsDisplay
                metrics={state.metrics}
                printers={state.printers}
                onPrintReport={handlePrintReport}
              />
            )}
          </CardContent>
        </Card>

        {state.sales && (
          <>
            <SalesTable sales={state.sales} metrics={state.metrics} />
            <ProductSummaryCard
              sales={state.sales}
              metrics={state.metrics}
              printers={state.printers}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ArqueoComponent;
